import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { updateAbility } from '@contexts/ability/Ability';
import AuthService, { localStorageKeys } from '@services/AuthService';
import HeaderContext from '@contexts/HeaderContext';
import UserService from '@services/UserService';
import { COMMON_ERRORS, HEADER, QUERY } from '@utils/constants';
import { existeID } from '@utils/Functions';
import { useSnackBars } from '@contexts/Snackbar/SnackBarContext';

const CurrentUserContext = createContext({});

export function CurrentUserProvider({ children }) {
  const [userData, setUserData] = useState({});
  const { header, setHeader } = useContext(HeaderContext);
  const { showErrorSnackbar } = useSnackBars();

  // useEffect para obtener los datos desde localStorage
  useEffect(() => {
    const storedUser = globalThis.window.localStorage.getItem(
      localStorageKeys.AUTH_USER,
    );

    if (storedUser && storedUser !== 'undefined') {
      setUserData(JSON.parse(storedUser));
    }
  }, []);

  const onGetCurrentUserSuccess = (data) => {
    updateAbility(data?.data?.roles);
    setUserData(data?.data);
    const userData = UserService.saveCurrentUserInLocalStorage(data);
    const irregularidades = userData?.data?.tiene_fichadas_irregulares;

    if (irregularidades && !existeID(header, HEADER.PRESENTISMO.id)) {
      setHeader([...header, HEADER.PRESENTISMO]);
    }
    if (!irregularidades && existeID(header, HEADER.PRESENTISMO.id)) {
      const newHeader = header.filter((e) => e?.id !== HEADER.PRESENTISMO.id);
      setHeader([...newHeader]);
    }
  };

  const onGetCurrentUserError = (error) => {
    const errorText = COMMON_ERRORS[error?.response_message];
    showErrorSnackbar(errorText);
    console.error(errorText);
  };

  const { isLoading, error } = useQuery(
    [QUERY.CURRENT_USER],
    UserService.getCurrentUser,
    {
      enabled: AuthService.isAuthenticated(),
      initialData: userData,
      onSuccess: onGetCurrentUserSuccess,
      onError: onGetCurrentUserError,
    },
  );

  const value = useMemo(
    () => ({ userData, setUserData, isLoading, error }),
    [userData, isLoading, error], // setUserData is stable
  );

  return (
    <CurrentUserContext.Provider value={value}>
      {children}
    </CurrentUserContext.Provider>
  );
}

export default CurrentUserContext;
